import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/db';

export function useSettings() {
  const settings = useLiveQuery(() => db.settings.toCollection().first());
  
  const updateSettings = async (updates: any) => {
    const current = await db.settings.toCollection().first();
    if (current?.id) {
      return db.settings.update(current.id, updates);
    } else {
      return db.settings.add({ ...updates, geminiApiKey: '', theme: 'dark' } as any);
    }
  };

  return { settings, updateSettings, isLoading: settings === undefined };
}
